import { render, staticRenderFns } from "./SupportResolved.vue?vue&type=template&id=192a2c88&scoped=true&"
import script from "./SupportResolved.vue?vue&type=script&lang=js&"
export * from "./SupportResolved.vue?vue&type=script&lang=js&"
import style0 from "./SupportResolved.vue?vue&type=style&index=0&id=192a2c88&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "192a2c88",
  null
  
)

export default component.exports